import React, {useState} from "react";
import {IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip} from "@mui/material";
import {grey} from "@mui/material/colors";
import {HugeiconsIcon} from "@hugeicons/react";
import {Calendar03Icon, Clock01Icon, Tick02Icon, Timer02Icon} from "@hugeicons/core-free-icons";
import {useDashboard} from "../../../../context/DashboardContext";
import {DEFAULT_RESPONSE_TIME_PERIOD, STATISTIC_PERIODS} from "../../../../repositories/DashboardRepository";

const PERIOD_ICONS = {
    MINUTES: Timer02Icon,
    HOURLY: Clock01Icon,
    DAYS: Calendar03Icon,
};

// Lets the user pick the bucket size (minute / hour / day) of one response-time card
export const PeriodMenu = ({type}) => {
    const {responseTimeWindows, setResponseTimePeriod} = useDashboard();
    const [anchorEl, setAnchorEl] = useState(null);

    const picked = responseTimeWindows?.[type]?.period || DEFAULT_RESPONSE_TIME_PERIOD;
    const current = STATISTIC_PERIODS.find(p => p.value === picked);

    return (
        <>
            <Tooltip title={`By ${current.label.toLowerCase()}`}>
                <IconButton
                    size={"small"}
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    sx={{borderRadius: "50% !important", color: grey[500]}}
                >
                    <HugeiconsIcon icon={PERIOD_ICONS[picked]} size={16}/>
                </IconButton>
            </Tooltip>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}
                  anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                  transformOrigin={{vertical: "top", horizontal: "right"}}>
                {STATISTIC_PERIODS.map(period => (
                    <MenuItem
                        key={period.value}
                        dense
                        selected={period.value === picked}
                        onClick={() => {
                            setAnchorEl(null);
                            // Picking the current period again jumps back to the live window
                            setResponseTimePeriod(type, period.value);
                        }}
                        sx={{gap: 1, minWidth: 180}}
                    >
                        <ListItemIcon sx={{minWidth: "24px !important", color: grey[600]}}>
                            <HugeiconsIcon icon={PERIOD_ICONS[period.value]} size={18}/>
                        </ListItemIcon>
                        <ListItemText
                            primary={period.label}
                            secondary={period.windowLabel}
                            secondaryTypographyProps={{fontSize: 11}}
                        />
                        {period.value === picked && <HugeiconsIcon icon={Tick02Icon} size={16}/>}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};
